import comsStore from '@mfe-4cs/state/ComsStore';
import { render } from 'lit';
import { createCustomerAttributeInteraction } from '@mfec/customerAttributes/createCustomerAttributeInteraction';
import type { TefComs4csMicroFrontend } from '../tef-coms4cs';

export function replaceElements(
  this: TefComs4csMicroFrontend,
  text?: string,
  disabled: boolean = false,
): string | undefined {
  if (!text) return undefined;
  const oDiv = document.createElement('div');
  oDiv.innerHTML = text;

  createCustomerAttributeInteraction(oDiv);

  if (!disabled) {
    const tooltipTemplate = this.getTemplateFn('tooltipTemplate');
    const allAbbr: NodeListOf<HTMLElement> = oDiv.querySelectorAll('abbr[title]');
    allAbbr.forEach((node) => {
      const target$ = new DocumentFragment();
      render(tooltipTemplate(comsStore.config?.styleContext as string, node.title, node.innerHTML), target$);
      node.replaceWith(target$);
    });
  }

  const replaceElementsWithTemplates = (selector: string, templateName: string) => {
    const found = oDiv.querySelectorAll<HTMLElement>(selector);
    const templateFunc = this.getTemplateFn(templateName);
    found.forEach((node) => {
      const target$ = new DocumentFragment();
      render(templateFunc(node), target$);
      node.replaceWith(target$);
    });
  };

  if (!this.occlUri) {
    replaceElementsWithTemplates('a', 'linkTemplate');
    replaceElementsWithTemplates('em', 'emTemplate');
    replaceElementsWithTemplates('div.coms-paragraph-1', 'comsP1Template');
  }

  return oDiv.innerHTML;
}
export const localDate = (date?: string): string | null => (date ? new Date(date).toLocaleDateString('de') : null);

export const localTime = (date?: string): string | null => (date ? new Date(date).toLocaleTimeString('de') : null);
